"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedgiftbagsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 19 22",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedgiftbagsm` : '') + (description ? ` desc-brandedgiftbagsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedgiftbagsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedgiftbagsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.02 6.02c.06-.3.41-.52.82-.52h11.5c.41 0 .77.24.81.55l2.18 15.27c.05.37-.33.68-.82.68H.82c-.5 0-.88-.33-.81-.7L3.02 6.02Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.03 6.87c0-.25.3-.45.66-.45h5.59c.36 0 .65.2.65.45 0 .26-.3.46-.65.46h-5.6c-.36 0-.65-.2-.65-.46Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65 3.85a7.5 7.5 0 0 0-1.81-1.46c-.4-.19-.9-.05-1.1.3-.21.35-.06.78.33.97a8.55 8.55 0 0 0 2.88.53l-.3-.34Zm.65.94v-.02.02Zm.38-.66a.1.1 0 0 1 .03-.01h-.03Zm1.23.98c.65-1.09-2.04-3.49-3.27-4.06-1.23-.58-2.76-.16-3.41.93-.66 1.09-.2 2.44 1.03 3.02 1.23.58 4.99 1.2 5.65.11Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.68 3.85a7.5 7.5 0 0 1 1.82-1.46.87.87 0 0 1 1.1.3c.2.35.06.78-.34.97a8.55 8.55 0 0 1-2.87.53c.08-.1.18-.22.3-.34Zm-.65.94v-.02.02Zm-.38-.66a.1.1 0 0 0-.02-.01h.02Zm-1.22.98c-.66-1.09 2.03-3.49 3.26-4.06 1.23-.58 2.76-.16 3.42.93.65 1.09.19 2.44-1.04 3.02-1.23.58-4.99 1.2-5.64.11Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.35 5.5H11v.92H7.33l.02-.92Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.35 7.33H11V22H7.33l.02-14.67Z",
    fill: "#E90B5A"
  }));
};
var _default = exports.default = brandedgiftbagsm;